import React, { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom';
import watsIcon from '../assest/home/5357b4eb16238760df0ba166628f1cee41086e44.png';
import styleAcc from '../css/backgrounds/accServices.module.css';
import '../css/AllServices.css';
function AccountingServices() {
    const serviceRefs = useRef([]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate-in');
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                threshold: 0.1,
                rootMargin: '0px 0px -50px 0px'
            }
        );

        serviceRefs.current.forEach((ref) => {
            if (ref) observer.observe(ref);
        });

        return () => {
            serviceRefs.current.forEach((ref) => {
                if (ref) observer.unobserve(ref);
            });
        };
    }, []);

    const addToRefs = (el, index) => {
        if (el && !serviceRefs.current.includes(el)) {
            serviceRefs.current[index] = el;
        }
    };

    return (
        <>
        <head style={{all:'initial'}}>
                <title>أفضل محاسب قانوني بالرياض</title>
                <meta name="description" content="أفضل محاسب قانوني بالرياض"/>
                <meta name="keywords" content="أفضل محاسب قانوني بالرياض" />
            </head>
            <div className="services-name">
                <div className={`${styleAcc.back1} service-item`} ref={(el) => addToRefs(el, 0)}>
                    <h1>مسك الدفاتر المحاسبية</h1>
                    <div>
                        <span><Link to='/services/booAccrec'>التفاصيل</Link></span>
                        <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                            <Link to='https://wa.me/+966564716444?text=السلام عليكم. عندي استفسار عن الدفاتر المحاسبية'>أطلب الان</Link>
                        </span>
                    </div>
                </div>
                <div className={`${styleAcc.back2} service-item`} ref={(el) => addToRefs(el, 1)}>
                    <h1>التهيئة والتدريب على الأنظمة المحاسبية</h1>
                    <div>
                        <span><Link to='/services/settraacc'>التفاصيل</Link></span>
                        <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                            <Link to='https://wa.me/+966564716444?text=السلام عليكم. عندي استفسار عن التدريب على الانظمة المحاسبية'>أطلب الان</Link>
                        </span>
                    </div>
                </div>
                <div className={`${styleAcc.back3} service-item`} ref={(el) => addToRefs(el, 2)}>
                    <h1>فحص اداء الأنظمة المحاسبية</h1>
                    <div>
                        <span><Link to='/services/accsysper'>التفاصيل</Link></span>
                        <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                            <Link to='https://wa.me/+966564716444?text=السلام عليكم. اريد استفسر عن فحص اداء الانظمة  المحاسبية'>أطلب الان</Link>
                        </span>
                    </div>
                </div>
                <div className={`${styleAcc.back4} service-item`} ref={(el) => addToRefs(el, 3)}>
                    <h1>إدارة المخازن والجرد</h1>
                    <div>
                        <span><Link to='/services/warinvman'>التفاصيل</Link></span>
                        <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                            <Link to='https://wa.me/+966564716444?text=السلام عليكم. اريد استفسر عن إدارة المخازن والجرد'>أطلب الان</Link>
                        </span>
                    </div>
                </div>
                <div className={`${styleAcc.back5} service-item`} ref={(el) => addToRefs(el, 4)}>
                    <h1>تقديم إستشارات محاسبية</h1>
                    <div>
                        <span><Link to='/services/proacccon'>التفاصيل</Link></span>
                        <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                            <Link to='https://wa.me/+966564716444?text=السلام عليكم. اريد استشارة محاسبية'>أطلب الان</Link>
                        </span>
                    </div>
                </div>
                <div className={`${styleAcc.back6} service-item`} ref={(el) => addToRefs(el, 5)}>
                    <h1>تزويد المنشأة بالانظمة المحاسبية بما يتناسب مع احتياجات النشاط</h1>
                    <div>
                        <span><Link to='/services/proaccsys'>التفاصيل</Link></span>
                        <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                            <Link to='https://wa.me/+966564716444?text=السلام عليكم. اريد نظام محاسبي'>أطلب الان</Link>
                        </span>
                    </div>
                </div>
                <div className={`${styleAcc.back7} service-item`} ref={(el) => addToRefs(el, 6)}>
                    <h1>إعداد القرارات الضريبية</h1>
                    <div>
                        <span><Link to='/services/pretaxdec'>التفاصيل</Link></span>
                        <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                            <Link to='https://wa.me/+966564716444?text=السلام عليكم. اريد استفسر عن إعداد القرارات الضريبية'>أطلب الان</Link>
                        </span>
                    </div>
                </div>
                <div className={`${styleAcc.back8} service-item`} ref={(el) => addToRefs(el, 7)}>
                    <h1>إعداد التقارير المالية والإدارية والختامية</h1>
                    <div>
                        <span><Link to='/services/prefinadmfin'>التفاصيل</Link></span>
                        <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                            <Link to='https://wa.me/+966564716444?text=السلام عليكم. اريد استفسر عن إعداد التقارير المالية والادارية'>أطلب الان</Link>
                        </span>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AccountingServices